import { 
  formatDate_short_dd_MM, 
  getDayOfTheWeek, 
  parseDateISO 
} from "~/util/date-n-time";

export function convertToDateFromString(date_str: string, locale: string) {
  return formatDate_short_dd_MM(parseDateISO(date_str), locale);
}

export function parseDayFromString(date_str: string, locale: string, style: Intl.ListFormatStyle = 'short') {
  const day = getDayOfTheWeek(locale, parseDateISO(date_str).getDay(), style);
  return day.name;
}